import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useTable, useSortBy, usePagination } from 'react-table'
import moment from "moment";
import { fetchServiceVessels } from '../../redux/action/company-vessel-chart.action';
import { changeCompany, getUserCompanies, getUserSetting, loadUser, saveCurrentCompany } from '../../redux/action/user.action';
import { fetchShipyardsData } from '../../redux/action/map-data.action';
import { fetchVesselDetailById } from '../../redux/action/vessels.action';



export const PageTitle = (props) => {
  const dispatch = useDispatch();
  let settings = useSelector(state => state.user.settings);
  let companies = useSelector(state => state.user.companies)
  let user = useSelector(state => state.user)


  useEffect(() => {
    dispatch(loadUser());
    dispatch(fetchVesselDetailById(vesselDetailId));
  }, []);


  let vesselDetail = useSelector(state => state.vessel.detail)

  useEffect(() => {


  }, [companies, settings]);

  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="row">
            <div className="col-xs-12" style={{ lineHeight: "62px" }}>
              <div id="dashboardTitle" style={{ fontSize: "larger", fontWeight: "bold", display: "inline-block", verticalAlign: "bottom" }} className="title-main">Equipment: {vesselDetail.detailValueForSearch}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageTitle;